import React, { useCallback } from 'react'
import { ActionModal } from '../ActionModal/ActionModal'

export type InactivityModalMetaData = {
    onConfirm: () => void
    isResumeModal?: boolean
}

export type InactivityModalProps = {
    getVisibility: () => boolean
    getMetaData: () => InactivityModalMetaData | undefined
    onConfirm: () => void
}

export const InactivityModal: React.FC<InactivityModalProps> = (props: InactivityModalProps) => {
    const metaData = props.getMetaData()
    const isResumeModal = metaData?.isResumeModal ?? false

    const getModalContent = useCallback(() => {
        if (isResumeModal) {
            return {
                message: 'The task timer has been paused due to prolonged inactivity.',
                primaryButton: 'Resume Task',
                onPrimary: props.onConfirm,
            }
        }

        return {
            message: "You've been inactive for a while. Are you still working on this task?",
            primaryButton: 'Yes',
            onPrimary: props.onConfirm,
        }
    }, [isResumeModal, props.onConfirm])

    const content = getModalContent()

    return (
        <ActionModal
            getVisibility={props.getVisibility}
            title={'Task Window Inactive'}
            content={content.message}
            primaryButtonName={content.primaryButton}
            onConfirm={content.onPrimary}
            closable={false}
        />
    )
}
